import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "navigation-sidebar__header"
}
const _hoisted_2 = { class: "navigation-sidebar__space-info" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "navigation-sidebar__space-info" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = ["title"]

import { computed, ref, watch } from 'vue';
import { Skeleton } from '@progress/kendo-vue-indicators';
import Tooltip from '@/components/common/tooltip/Tooltip.vue';
import { useSpaceStore } from '@/stores/space.store';
import useTranslations from '@/composables/useTranslations';
import ideaDefaultImage from '@/assets/images/defaults/space-default-image.png';


export default /*@__PURE__*/_defineComponent({
  __name: 'NavigationSidebarHeader',
  props: {
    expanded: { type: Boolean }
  },
  emits: ["spaceImageLoaded"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const spaceStore = useSpaceStore();
const { translate: t } = useTranslations();

const isSpaceImageLoading = ref(true);

const isLoading = computed(() => !spaceStore.isSpaceDetailsLoaded || isSpaceImageLoading.value);
const spaceImageSrc = computed(() =>
  spaceStore?.spaceDetails?.isSpaceImageExists
    ? `/files/spaceimage?spaceId=${spaceStore?.spaceDetails?.id}`
    : ideaDefaultImage,
);

function onSpaceImageLoad() {
  isSpaceImageLoading.value = false;
  emit('spaceImageLoaded');
}

watch(
  () => spaceStore.spaceDetails?.id,
  (id) => {
    isSpaceImageLoading.value = true;
    if (!id || id <= 0) {
      isSpaceImageLoading.value = false;
      return;
    }
    // Preload into browser cache so the tooltip <img> renders instantly
    const img = new Image();
    img.src = spaceImageSrc.value;
    img.onload = img.onerror = onSpaceImageLoad;
  },
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(Skeleton), {
            shape: 'rectangle',
            animation: { type: 'pulse' },
            style: { width: '42px', height: '42px', 'border-radius': '6px' },
            tabindex: "-1"
          }),
          (__props.expanded)
            ? (_openBlock(), _createBlock(_unref(Skeleton), {
                key: 0,
                shape: 'text',
                animation: { type: 'pulse' },
                style: { width: '120px', height: '22px' },
                tabindex: "-1"
              }))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_unref(spaceStore)?.spaceDetails?.id > 0)
      ? (_openBlock(), _createBlock(Tooltip, {
          key: 1,
          filter: () => !__props.expanded,
          "class-name": 'navigation-sidebar-tooltip',
          "open-delay": 0,
          position: 'right',
          "anchor-element": 'target',
          "parent-title": true
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "navigation-sidebar__header",
              title: _unref(spaceStore)?.spaceDetails?.name
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: spaceImageSrc.value,
                  alt: _unref(t)('Space.Image'),
                  class: "navigation-sidebar__space-info-image"
                }, null, 8, _hoisted_5),
                (__props.expanded)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "navigation-sidebar__space-info-name",
                      title: _unref(spaceStore)?.spaceDetails?.name
                    }, _toDisplayString(_unref(spaceStore)?.spaceDetails?.name), 9, _hoisted_6))
                  : _createCommentVNode("", true)
              ])
            ], 8, _hoisted_3)
          ]),
          _: 1
        }, 8, ["filter"]))
      : _createCommentVNode("", true)
}
}

})